import { ModelBase } from 'store/model-base';

export class CmsLevelMoveError extends ModelBase {
    public static storeName: string = 'cmsLevelMoveError';

    public errors: CmslevelMoveErrorContent[];
}
